module.exports = __webpack_public_path__ + "img/slide02_sp.7feae564.png";